import React from 'react';
import { Typography } from '@worthy-npm/worthy-common-ui-components';
import { useAppSelector } from '../../app/hooks';
import { getShipmentAddress } from '../../slices/schedulingSlice';

function AddressLabel() {
  const shipmentAddress = useAppSelector(getShipmentAddress);
  return (
    <>
      Location Information
      {shipmentAddress && (
        <>
          {' '}
          -
          {' '}
          <Typography
            component="span"
            fontWeight="inherit"
            color="text.primary"
            display="inline-block"
          >
            {shipmentAddress}
          </Typography>
        </>
      )}
    </>
  );
}

export default AddressLabel;
